var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLinkedin = function SvgIconLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2066",
    "data-name": "Grupo 2066",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3986",
    "data-name": "Caminho 3986",
    d: "M82.925,189.513a15,15,0,1,0-15-15,15,15,0,0,0,15,15",
    transform: "translate(-67.925 -159.513)",
    fill: "#0074bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3987",
    "data-name": "Caminho 3987",
    d: "M90.956,194.213H87.923V183.959h3.033Zm-1.594-11.536H89.34a1.863,1.863,0,1,1,.021,0m13.729,11.536H99.652v-5.306c0-1.389-.538-2.337-1.721-2.337a1.752,1.752,0,0,0-1.642,1.257,2.484,2.484,0,0,0-.074.838v5.549H92.808s.044-9.4,0-10.254h3.407v1.609a3.089,3.089,0,0,1,3.028-1.708c2.155,0,3.848,1.475,3.848,4.651Z",
    transform: "translate(-80.311 -172.229)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-linkedin.272b8cd7.svg";
export { ForwardRef as ReactComponent };